import { FormProvider, UseFormReturn } from 'react-hook-form'
import { connect, DataItem } from 'scrivito'

import { DocumentDrawerFormBody } from './DocumentDrawerForm.Body'
import { Form, FormHeader } from '@/Atomic/Templates/Form'
import { getDataItemTitle } from '@/utils/dataClassMap'

interface DocumentDrawerFormProps {
  dataItem: DataItem
  methods: UseFormReturn
  onFormSubmit?: () => void
  isEditing: boolean
}

export const DocumentDrawerForm: React.FC<DocumentDrawerFormProps> = connect(
  ({ dataItem, isEditing, methods, onFormSubmit }) => {
    const title = getDataItemTitle(dataItem)

    return (
      <FormProvider {...methods}>
        <Form onSubmit={onFormSubmit}>
          <FormHeader>{title}</FormHeader>
          <DocumentDrawerFormBody dataItem={dataItem} isEditing={isEditing} />
        </Form>
      </FormProvider>
    )
  },
)
